var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvalcarSigle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#04B2B2",
    d: "M200,185c0,8.284-6.716,15-15,15H15c-8.284,0-15-6.716-15-15V15C0,6.716,6.716,0,15,0h170 c8.284,0,15,6.716,15,15V185z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M152,35.016c0,6.627-5.373,12-12,12h-26c-6.627,0-12-5.373-12-12v-1c0-6.627,5.373-12,12-12h26 c6.627,0,12,5.373,12,12V35.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.737,165.667c-0.573,6.55-6.348,11.396-12.896,10.822l-0.19-0.019 c-6.55-0.572-11.395-6.347-10.821-12.896L69.263,32.884c0.573-6.55,6.348-11.395,12.896-10.822l0.19,0.018 c6.55,0.572,11.395,6.347,10.821,12.896L81.737,165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M141,164.535c0,6.627-5.373,12-12,12h-26c-6.627,0-12-5.373-12-12v-1c0-6.627,5.373-12,12-12h26 c6.627,0,12,5.373,12,12V164.535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147,97.5c0,6.902-5.598,12.5-12.5,12.5h-75c-6.903,0-12.5-5.598-12.5-12.5l0,0 C47,90.597,52.597,85,59.5,85h75C141.402,85,147,90.597,147,97.5L147,97.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvalcarSigle);
export default __webpack_public_path__ + "static/media/evalcar-sigle.0b755570fff80c2aec26b9677898208a.svg";
export { ForwardRef as ReactComponent };